import { getCountries, getCountryCallingCode } from 'libphonenumber-js'

export const countries = getCountries()
  .map(countryCode => ({
    code: countryCode,
    name: new Intl.DisplayNames(['en'], { type: 'region' }).of(countryCode),
    dialCode: `+${getCountryCallingCode(countryCode)}`
  }))
  .sort((a, b) => a.name.localeCompare(b.name))

export const getCountryByCode = (code) => {
  return countries.find(country => country.code === code) || countries.find(country => country.code === 'NL')
}
